export const subscriptionLimits = {
  starter: {
    users: 2,
    pools: 50,
    services: 200,
    repairs: 50,
    photos: {
      perService: 2,
      perRepair: 1,
    },
    price: {
      monthly: '39',
      yearly: '399',
    },
  },
  professional: {
    users: 5,
    pools: 150,
    services: 750,
    repairs: 150,
    photos: {
      perService: 4,
      perRepair: 2,
    },
    price: {
      monthly: '79',
      yearly: '799',
    },
  },
  business: {
    users: 15,
    pools: 'unlimited',
    services: 'unlimited',
    repairs: 'unlimited',
    photos: {
      perService: 10,
      perRepair: 4,
    },
    price: {
      monthly: '149',
      yearly: '1499',
    },
  },
};
